import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

const empty = { title: "", subtitle: "", image_url: "", cta_label: "", cta_link: "", active: true, order: 0 };

export default function AdminBanner() {
  const [banners, setBanners] = useState([]);
  const [form, setForm] = useState(empty);
  const [editingId, setEditingId] = useState(null);

  const load = () => api.get("/admin/banners").then((r) => setBanners(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      if (editingId) await api.put(`/admin/banners/${editingId}`, form);
      else await api.post("/admin/banners", form);
      toast.success("Salvato");
      setForm(empty); setEditingId(null); load();
    } catch { toast.error("Errore"); }
  };

  const edit = (b) => { setForm(b); setEditingId(b.id); };
  const del = async (id) => { if (!confirm("Eliminare?")) return; await api.delete(`/admin/banners/${id}`); load(); };

  return (
    <div data-testid="admin-banner" className="p-10 max-w-5xl">
      <h1 className="font-serif text-4xl text-white mb-2">Banner Homepage</h1>
      <p className="text-white/50 text-sm mb-10">Gestisci i banner promozionali della home.</p>

      <form onSubmit={save} className="luxe-card p-6 mb-8 space-y-4">
        <h3 className="font-serif text-xl text-white">{editingId ? "Modifica banner" : "Nuovo banner"}</h3>
        <div className="grid md:grid-cols-2 gap-4">
          <input required placeholder="Titolo" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="bg-transparent border border-white/15 px-4 py-2.5 text-white focus:border-[var(--gold)] outline-none" />
          <input placeholder="Sottotitolo" value={form.subtitle} onChange={(e) => setForm({ ...form, subtitle: e.target.value })} className="bg-transparent border border-white/15 px-4 py-2.5 text-white focus:border-[var(--gold)] outline-none" />
          <input placeholder="URL immagine" value={form.image_url} onChange={(e) => setForm({ ...form, image_url: e.target.value })} className="bg-transparent border border-white/15 px-4 py-2.5 text-white focus:border-[var(--gold)] outline-none md:col-span-2" />
          <input placeholder="Testo CTA" value={form.cta_label} onChange={(e) => setForm({ ...form, cta_label: e.target.value })} className="bg-transparent border border-white/15 px-4 py-2.5 text-white focus:border-[var(--gold)] outline-none" />
          <input placeholder="Link CTA" value={form.cta_link} onChange={(e) => setForm({ ...form, cta_link: e.target.value })} className="bg-transparent border border-white/15 px-4 py-2.5 text-white focus:border-[var(--gold)] outline-none" />
          <input type="number" placeholder="Ordine" value={form.order} onChange={(e) => setForm({ ...form, order: parseInt(e.target.value) || 0 })} className="bg-transparent border border-white/15 px-4 py-2.5 text-white focus:border-[var(--gold)] outline-none" />
          <label className="flex items-center gap-2 text-sm text-white/70"><input type="checkbox" checked={form.active} onChange={(e) => setForm({ ...form, active: e.target.checked })} /> Attivo</label>
        </div>
        <div className="flex gap-3">
          <button type="submit" className="btn-gold"><Plus size={14} /> {editingId ? "Aggiorna" : "Crea"}</button>
          {editingId && <button type="button" onClick={() => { setForm(empty); setEditingId(null); }} className="btn-ghost-gold">Annulla</button>}
        </div>
      </form>

      <div className="space-y-3">
        {banners.map((b) => (
          <div key={b.id} className="luxe-card p-5 flex justify-between gap-4">
            <div>
              <div className="flex gap-3 items-center mb-1">
                <span className="font-serif text-lg text-white">{b.title}</span>
                <span className={`text-xs px-2 py-0.5 rounded-sm ${b.active ? "bg-[var(--gold)]/20 text-[var(--gold)]" : "bg-white/10 text-white/40"}`}>{b.active ? "Attivo" : "Inattivo"}</span>
              </div>
              <div className="text-sm text-white/60">{b.subtitle}</div>
            </div>
            <div className="flex gap-2 shrink-0">
              <button onClick={() => edit(b)} className="text-xs px-3 py-1.5 border border-white/15 text-white/70 hover:border-[var(--gold)]">Modifica</button>
              <button onClick={() => del(b.id)} className="text-xs px-3 py-1.5 border border-red-500/30 text-red-400 hover:bg-red-500/10"><Trash2 size={12} /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
